import cn from 'classnames';
import { useIntl } from 'react-intl';

import { MEDIA_QUERIES, useSearch } from '@/shared/hooks';
import { Input } from '@/shared/ui';

import { PatientsFiltersType } from '@/entities/patient';

import { searchBarPlaceholders } from '../../config/i18n';

import styles from './PatientListSearch.module.scss';

type PatientListSearchProps = {
  onInputChange: (value: string) => void;
  currentPatientsFilter: PatientsFiltersType;
  className?: string;
};

export const PatientListSearch = ({
  onInputChange,
  currentPatientsFilter,
  className,
}: PatientListSearchProps) => {
  const { formatMessage } = useIntl();
  const [search, updateSearch] = useSearch(onInputChange);

  return (
    <Input
      data-component="patient-search-input"
      className={cn(styles.search, className)}
      inputWrapperClassName={styles.inputWrapper}
      inputClassName={styles.input}
      name="search"
      type="search"
      value={search}
      icon="search"
      inputMode="search"
      autoFocus={!window.matchMedia(MEDIA_QUERIES.isMobile).matches}
      autoComplete="off"
      placeholder={formatMessage(searchBarPlaceholders[currentPatientsFilter])}
      onChange={(event) => updateSearch(event.target.value)}
      onResetField={() => updateSearch('')}
    />
  );
};
